import getBasicDate from 'utils/dates/getBasicDate';
function shouldShowJoinMeetingLink(_ref) {
  var status = _ref.status,
    startDateTime = _ref.startDateTime,
    endDateTime = _ref.endDateTime,
    linkUrl = _ref.linkUrl;
  if (status !== 'booked' || !startDateTime || !endDateTime || !linkUrl) {
    return false;
  }
  var now = new Date();
  var startDate = new Date(startDateTime);
  var endDate = new Date(endDateTime);
  if (!isFinite(startDate.getTime()) || !isFinite(endDate.getTime())) {
    return false;
  }
  if (getBasicDate(startDate) !== getBasicDate(now)) {
    return false;
  }
  return now.getTime() <= endDate.getTime();
}
export default shouldShowJoinMeetingLink;